import { render, staticRenderFns } from "./ReferentielMulti3.vue?vue&type=template&id=37b60e4a&"
import script from "./ReferentielMulti3.vue?vue&type=script&lang=js&"
export * from "./ReferentielMulti3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports